import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'shared';
import { OAuthServiceService } from 'shared';
//import { PlatformGroupRoleService } from 'shared';
import { TenantService } from 'shared';
import { TranslateService } from 'shared';

@Component({
    selector: 'app-add-tenant-grouprole-dialog',
    templateUrl: './add-tenant-grouprole-dialog.component.html',
    styleUrls: ['./add-tenant-grouprole-dialog.component.css'],
    standalone: false
})
export class AddTenantGrouproleDialogComponent implements OnInit {

  groupRoleForm!: UntypedFormGroup;
  titleAlert: string = 'This field is required';


  constructor(
    private formBuilder: UntypedFormBuilder,
    public _dialogRef: MatDialogRef<AddTenantGrouproleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public translate: TranslateService,
    private notificationService: NotificationService,
    private tenantService: TenantService,
    private oauthService: OAuthServiceService

  ) {

  }
   ngOnInit(): void {
    this.createTGRForm();
  }
  createTGRForm() {
    this.groupRoleForm = this.formBuilder.group({
      name: [null, Validators.required],
      permissions: ['']
    });
  }

  onChange(permissions: string) {
    this.groupRoleForm.get('permissions')!.setValue(permissions);
  }
  cancel() {
    this._dialogRef.close();
  }

  isFormValid() {
    return this.groupRoleForm.valid;
  }
  
  add() {
    if (this.groupRoleForm.valid) {
      console.log(this.groupRoleForm.value)
      this._dialogRef.close(this.groupRoleForm.value);
    }
    else{
      this.notificationService.warning(`${this.translate.data["WARN"]}`, `${this.translate.data["USERREQUIREDFIELDS"]}`);
    }
  }


}

